module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-close-c13b7c364bd09a21689caed12fa8e56e.svg";